import ApiService from "@/api";
import { get } from "lodash";
// initial state
const state = () => ({
    loading: false,
    list: [],
    detail: {}
});

// getters
const getters = {};

// actions
const actions = {
    getCampingClubs(context) {
        const { commit, rootState } = context;
        commit("setLoading", true);
        let url = "/wp-json/wp/v2/camping_club";
        if (get(rootState, "app.lang") === "en") {
            url = `/en/wp-json/wp/v2/camping_club`;
        }
        return new Promise(resolve => {
            ApiService.get(url)
                .then(({ data }) => {
                    commit("setCampingClubs", data);
                    commit("setLoading", false);
                    resolve(data);
                })
                .catch(() => {
                    commit("setLoading", false);
                });
        });
    },
    getCampingClub(context, data) {
        const { commit, rootState } = context;
        commit("setLoading", true);
        // Same language convention as the list actions: the API serves the
        // translation of this id in the requested language.
        let url = `/wp-json/wp/v2/camping_club/${data.ID ? data.ID : data.id}`;
        if (get(rootState, "app.lang") === "en") {
            url = `/en${url}`;
        }
        return new Promise(resolve => {
            ApiService.get(url)
                .then(({ data }) => {
                    commit("setCampingClub", data);
                    commit("setLoading", false);
                    resolve(data);
                })
                .catch(() => {
                    commit("setLoading", false);
                });
        });
    }
};

// mutations
const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setCampingClubs(state, data) {
        state.list = data;
    },
    setCampingClub(state, data) {
        state.detail = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
